module.exports = __webpack_public_path__ + "static/media/yves-saint-laurent-y-by-ysl-big.91eb7c33.png";